import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Validation from '../Validation';
import './styles.css';

const Input = ({
  className,
  label,
  name,
  icon,
  image,
  placeholder,
  required,
  errorMessages,
  round,
  dirty,
  ...props
}) => {
  return (
    <div
      className={classNames('ModalForm__Input__wrapper', {
        'ModalForm__Input__wrapper--hidden': props && props.type === 'hidden',
        'ModalForm__Input__wrapper--round': round,
        [className]: className,
      })}
    >
      <label htmlFor={name}>
        {label}
        {icon && <i className={`ModalForm__Input__icon ${icon}`} />}
        {image && (
          <img className="ModalForm__Input__image" src={image} alt="" />
        )}
        <input
          name={name}
          autoComplete="off"
          className="ModalForm__Input__input"
          placeholder={`${placeholder}${required ? '*' : ''}`}
          required={required}
          {...props}
        />
      </label>
      <Validation errorMessages={errorMessages} dirty={dirty} />
    </div>
  );
};

Input.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  icon: PropTypes.string,
  image: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  round: PropTypes.bool,
  error: PropTypes.arrayOf(PropTypes.shape({})),
  valid: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

Input.defaultProps = {
  label: '',
  name: '',
  icon: '',
  image: '',
  placeholder: '',
  required: undefined,
  error: [],
  valid: undefined,
  round: undefined,
};
export default Input;
